import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { TournamentsResponse } from '../../all-tournaments/models/api/responses/tournaments.response';
import { Filter } from '../../all-tournaments/store/actions/allTournaments.action';
import { endpoints } from '../../utils/endpoints';
import {
    GamesListResponse,
    GenresResponse, PlatformsResponse,
} from '../models/api/responses/games.response';
import { Game, GameFormat } from '../models/games.interface';
import { RegionsListResponse } from 'src/app/all-tournaments/models/api/responses/regions.response';

@Injectable(
    {
        providedIn: 'root',
    }
)
export class GamesService {
    private http = inject(HttpClient);


    getGamesList(): Observable<GamesListResponse> {
        let params = new HttpParams();
        params = params.append('includeOptions', true);

        return this.http
            .get<GamesListResponse>(endpoints.gameList.children.newGames(), {
                params,
            })
            .pipe(shareReplay());
    }

    checkInGameAccountId(gameId: string, inGameId: string) {
        return this.http
            .head(
                endpoints.gameList.children.getCheckInGameAccountId(
                    gameId,
                    inGameId
                )
            )
            .pipe(shareReplay());
    }

    getGameById(id: string): Observable<Game> {
        return this.http
            .get<Game>(endpoints.gameList.children.getGameById(id))
            .pipe(shareReplay());
    }

    getGameByIdV1(id: string): Observable<Game> {
        let params = new HttpParams();
        params = params.append('includeOptions', true);
        return this.http
            .get<Game>(endpoints.gameList.children.getGameByIdV1(id), { params })
            .pipe(shareReplay());
    }

    getTournamentsByGame(page: number, gameId: string, filters: Filter, useV2Base?: boolean) {
        return this.http
            .get<TournamentsResponse>(
                endpoints.tournaments.children.getTournamentsByGame({
                    page,
                    gameId,
                    filters,
                    useV2Base,
                })
            )
            .pipe(shareReplay());
    }

    fetchGenres() {
        return this.http
            .get<GenresResponse>(endpoints.genres.children.fetchGenres())
            .pipe(shareReplay());
    }

    fetchPlatforms() {
        return this.http
            .get<PlatformsResponse>(endpoints.platforms.children.fetchPlatforms())
            .pipe(shareReplay());

    }

    fetchFormats(gameId: string) {
        return this.http
            .get<GameFormat[]>(endpoints.formats.children.fetchGameFormats(gameId))
            .pipe(shareReplay());

    }

    getRegions() {
        return this.http.get<RegionsListResponse>(endpoints.tournaments.children.getRegions());
    }
    getRegionsV2() {
        return this.http.get<RegionsListResponse>(endpoints.tournaments.children.getRegionsV2());
    }
}
